import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useLanguage } from '../components/Layout/LanguageContext';

const ImprintSection = styled.section`
  min-height: 100vh;
  padding: 100px 2rem;
  background: var(--background);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled(motion.h1)`
  font-size: 3rem;
  font-weight: 700;
  color: var(--primary);
  margin-bottom: 3rem;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Content = styled(motion.div)`
  background: var(--card-background);
  padding: 3rem;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  line-height: 1.8;
  color: var(--text);
  
  h2 {
    color: var(--primary);
    font-size: 2rem;
    margin: 2rem 0 1rem 0;
    font-weight: 600;
  }
  
  h3 {
    color: var(--secondary);
    font-size: 1.5rem;
    margin: 1.5rem 0 1rem 0;
    font-weight: 500;
  }
  
  p {
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }
  
  ul {
    margin: 1rem 0;
    padding-left: 2rem;
  }
  
  li {
    margin-bottom: 0.5rem;
  }
  
  a {
    color: var(--primary);
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  strong {
    color: var(--primary);
    font-weight: 600;
  }
  
  @media (max-width: 768px) {
    padding: 2rem;
    
    h2 {
      font-size: 1.5rem;
    }
    
    h3 {
      font-size: 1.3rem;
    }
  }
`;

const ImprintEN: React.FC = () => {
  const { setLanguage } = useLanguage();
  
  // Set language to English when component mounts
  React.useEffect(() => {
    setLanguage('en');
  }, [setLanguage]);

  return (
    <ImprintSection>
      <Container>
        <Title>Site Notice</Title>
        <Content>
          <p>Yannick Reinke<br />
          IT Beratung<br />
          Arnikaweg 2<br />
          87527 Sonthofen</p>
          
          <h2>Contact</h2>
          <p>Phone: +491604296531<br />
          E-mail: kontakt@it-beratung-reinke.de</p>
          
          <h2>Information regarding professional liability insurance</h2>
          <p><strong>Name and registered office of the insurer:</strong><br />
          exali AG - Das Versicherungsportal für Dienstleister und freie Berufe<br />
          Franz-Kobinger-Str. 9<br />
          86157 Augsburg</p>
          <p><strong>Scope of insurance:</strong><br />Weltweit</p>
          
          <h2>Dispute resolution proceedings in front of a consumer arbitration board</h2>
          <p>We are not willing or obliged to participate in dispute resolution proceedings in front of a consumer arbitration board.</p>
        </Content>
      </Container>
    </ImprintSection>
  );
};

export default ImprintEN;
